import Mustache from 'mustache';
import moment from "moment";
import _ from "lodash";

export default class ParameterHandler {
  static replaceParams(appId, route, params, fileId) {
    if(!route) return route;
    let userProfile=OSjs.make("oxzion/profile").get().key;
    const interpolationContext = {
      ...params,
      fileId,
      appId,
      current_date : moment().format("YYYY-MM-DD"),
      userProfile:userProfile,
      assignedto:params?.assigned_to,
      profile:userProfile,
    }
    if (typeof route == "object") {
      var final_route = JSON.parse(JSON.stringify(route));
      Object.keys(route).map((item) => {
        if (/\{\{.*?\}\}/g.test(route[item])) {
          if (interpolationContext[item]) {
            final_route[item] = interpolationContext[item];
          } else {
            if (item == "appId") {
              final_route[item] = appId;
            } else if (item == "fileId" && fileId) {
              final_route[item] = fileId;
            } else {
              final_route[item] = route[item];
            }
            final_route[item] = Mustache.render(route[item], interpolationContext);
          }
        } else {
          final_route[item] = route[item];
        }
      });
      return final_route;
    } else {
      return route ? Mustache.render(route, interpolationContext) : route;
    }
  }

  static async updateCall(core, appId, route, body, disableAppId, method) {
    let helper = core.make("oxzion/restClient");
    route = disableAppId ? route : "/app/" + appId + "/" + route;
    let formData = await helper.request("v1", route, method == "GET" ? {} : body, method ? method.toLowerCase() : "post");
    return formData;
  }

  static async downloadFile(response) {
    try {
      const file = await response.blob();
      const fileName = response.headers
        .get("content-disposition")?.split(";")?.find((n) => n.includes("filename="))?.replace("filename=", "")?.replaceAll('"', "")?.trim();

      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, fileName);
      else {
        const ele = document.createElement("a");
        ele.href = URL.createObjectURL(file);
        ele.download = fileName ?? 'Exported_File';
        ele.click();
      }
      return true;
    } catch (error) {
      return false;
    }
  }
}